// src/components/Banner.jsx
import React, { useState } from 'react';
import { Container, Row, Col, Button, Collapse } from 'react-bootstrap';
import { FaBars, FaTimes } from "react-icons/fa";
import '../assets/styles/banner.css';

import logo from '../assets/images/logo.png';
import phoneIcon from '../assets/images/phonenumbericon.svg';
import whatsappIcon from '../assets/images/whatsappicon.svg';
import btnIcon4 from '../assets/images/btn-icon-4.svg';
import innerRing from '../assets/images/inner-ring.svg';
import outerRing from '../assets/images/outer-ring.svg';
import maskGroup from '../assets/images/mask-group.png';
import profPic1 from '../assets/images/professional-pic-1.png';
import profPic2 from '../assets/images/professional-pic-2.png';
import profPic3 from '../assets/images/professional-pic-3.png';
import profPic4 from '../assets/images/professional-pic-4.png';
import profPicMain from '../assets/images/professional-pic.png';
import frameIcon from '../assets/images/frame.svg';

const Banner = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { label: "Home", href: "#home" },
    { label: "Services", href: "#services" },
    { label: "Pricing", href: "#pricing" },
    { label: "How It Works", href: "#howitworks" },
    { label: "Why Rest Assured?", href: "#whytrustrest" },
    { label: "Contact", href: "#requestcallback" },
    { label: "FAQ", href: "#faqsection" },
  ];

  const handleMenuClick = () => {
    setIsOpen(false);
  };

  return (
    <div className="banner" id="home">
      <Container fluid className="banner-container">
        {/* NAVBAR */}
        <div className="custom-navbar">
          <Row className="align-items-center py-3 px-3 gx-0">
            <Col xs="auto">
              <img className="logo" src={logo} alt="Logo" />
            </Col>

            <Col xs className="d-md-none text-end">
              <button
                className="menu-toggle-btn"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Toggle Menu"
              >
                {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </button>
            </Col>

            <Col md className="d-none d-md-flex justify-content-end flex-wrap gap-3">
              {menuItems.map((item, idx) => (
                <a key={idx} href={item.href} className="menu text-decoration-none">
                  <div className="text-wrapper">{item.label}</div>
                </a>
              ))}
            </Col>
          </Row>

          <Collapse in={isOpen}>
            <div className="d-md-none mobile-menu p-3">
              {menuItems.map((item, idx) => (
                <a
                  key={idx}
                  href={item.href}
                  className="menu text-decoration-none d-block mb-2"
                  onClick={handleMenuClick}
                >
                  <div className="text-wrapper">{item.label}</div>
                </a>
              ))}
            </div>
          </Collapse>
        </div>

        {/* BANNER CONTENT */}
        <Row className="align-items-center mt-5">
          <Col xs={12} lg={6} className="text-start">
            <h1 className="banner-heading">
              <span className="highlight-gradient">Hassle–Free</span> Home Maintenance in Kerala
            </h1>
            <p className="p">
              Professional property maintenance, cleaning, and repairs – just one call away
            </p>
            <div className="banner-buttons d-flex flex-row flex-nowrap gap-2 mt-4 align-items-center align-items-md-start justify-content-center justify-content-md-start">
              <a href="tel:+919633718181" className="btn btn-primary primary-btn-medium d-flex align-items-center justify-content-center text-decoration-none">
                <img src={phoneIcon} alt="Phone Icon" width="20" height="20" />
                <span className="ms-2">+91 96337 18181</span>
              </a>
              <a
                href="https://wa.me/919633718181"
                target="_blank"
                rel="noopener noreferrer"
                className="btn whatsapp-btn-medium d-flex align-items-center justify-content-center"
              >
                <img src={whatsappIcon} alt="WhatsApp Icon" width="20" height="20" />
                <span className="ms-2">Chat on WhatsApp</span>
              </a>
              <Button variant="outline-primary" className="secondary-btn-medium d-flex align-items-center justify-content-center">
                <img src={btnIcon4} alt="Request Callback" width="20" height="20" />
                <span className="ms-2">Request a Callback</span>
              </Button>
            </div>
          </Col>

          <Col lg={6} className="position-relative text-center text-lg-end mt-5 mt-lg-0">
            <div className="art-and-badge-wrapper">
              <div className="ring-layer">
                <img className="inner-ring" src={innerRing} alt="Inner Ring" />
                <img className="outer-ring" src={outerRing} alt="Outer Ring" />
                <img className="mask-group" src={maskGroup} alt="Mask" />
              </div>

              <div className="frame-3 text-white">
                <div className="frame-3-title">
                  Background-Verified Professionals
                </div>
                <div className="frame-4">
                  <img className="professional-pic" src={profPic3} alt="Professional 3" />
                  <img className="professional-pic-2" src={profPic4} alt="Professional 4" />
                  <img className="professional-pic-2" src={profPicMain} alt="Professional" />
                  <img className="professional-pic-2" src={profPic1} alt="Professional 1" />
                  <img className="professional-pic-2" src={profPic2} alt="Professional 2" />
                  <div className="frame-5">
                    <div className="professional-pic-3">
                      <img className="frame-6" src={frameIcon} alt="Checkmark" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Banner;
